<template>
    <div class="videoMonitor">
      视频监控
    </div>
</template>

<script>
import url from "../../service/base-url.js";
export default {
  name: "videoMonitor",
  mounted() {
    // var win = window.open(url.smartDevice, "_blank");
    // win.focus();
  }
};
</script>

<style lang="stylus" scoped>
    
</style>
